












































































































































import Vue from 'vue'
import _ from 'lodash'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import {
  FETCH_ADDRESS_FELD_LIST,
  FETCH_ADDRESS_GROUP,
  FETCH_LAND_LIST,
  FETCH_SEARCH_ADDRESS_LIST
} from '@/store/action-types'
import { Land } from '@/model/addresses/Land'
import AddressWindow from '@/components/master-data/address/AddressWindow.vue'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import {
  AdressZusatzfelderType,
  AdressZusatzfelderTypesResponse,
  ProjectAddressSearchResponse
} from '@/types/service-response'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import { AdressZusatzfelderSearchItem, ProjectAddressSearchRequestPayload } from '@/types/payload'
import { AddressCountry } from '@/model/addresses/AddressCountry'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { loadMessages, locale } from 'devextreme/localization'
import { KeyAction } from '@/model/KeyAction'
import { KeyActionEnum } from '@/types/enums'
import { keyActionService } from '@/services/key-action-service'

class SelectAll extends KeyAction {}

interface ComponentData {
  tableHeight: string,
  loading: boolean
  showDialog: boolean
  addressIdList: number[]

  landList: Land[]
  addressGroupList: AddressGroup[]

  sortierung: string
  name: string
  vorname: string
  ort: string
  plz: string
  strasse: string
  hausnummer: string
  region: string
  land: AddressCountry | undefined
  adressgruppe: number | undefined
  telefonprivate: string
  telefonGeschaeftlich: string
  handyprivat: string
  handygeschaeftlich: string
  mailprivat: string
  mailgeschaftlich: string
  maxRecords: number

  addressList: SearchAddress[]
  isDetailButtonDisabled: boolean
  addressStatus: string
  feldList: AdressZusatzfelderType[]
  operatorList: any[]
  boolOperatorNextList: any[]
  additionalFilterList: any[]

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'AddressSearchPage',

  components: {
    AddressWindow,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    addressGroupId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,
      showDialog: false,
      addressIdList: [],

      landList: [],
      addressGroupList: [],

      sortierung: '',
      name: '',
      vorname: '',
      ort: '',
      plz: '',
      strasse: '',
      hausnummer: '',
      region: '',
      land: undefined,
      adressgruppe: undefined,
      telefonprivate: '',
      telefonGeschaeftlich: '',
      handyprivat: '',
      handygeschaeftlich: '',
      mailprivat: '',
      mailgeschaftlich: '',
      maxRecords: 500,

      addressList: [],
      isDetailButtonDisabled: true,
      addressStatus: '1',
      feldList: [],
      operatorList: [
        {id: 1, name: '='},
        {id: 2, name: this.$t('productSearch.operator1').toString()},
        {id: 3, name: this.$t('productSearch.operator2').toString()},
        {id: 4, name: this.$t('productSearch.operator3').toString()},
        {id: 5, name: this.$t('productSearch.operator4').toString()},
        {id: 6, name: this.$t('productSearch.operator5').toString()},
        {id: 7, name: this.$t('productSearch.operator6').toString()},
        {id: 8, name: this.$t('productSearch.operator7').toString()}
      ],
      boolOperatorNextList: [
        {id: 0, name: ''},
        {id: 1, name: this.$t('productSearch.boolOperator1').toString()},
        {id: 2, name: this.$t('productSearch.boolOperator2').toString()}
      ],
      additionalFilterList: [
        {id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}
      ],

      keyActions: []
    }
  },

  watch: {
    $route (newVal: any): void {
      if(newVal.query.create) {
        this.addressIdList = [0]
        this.showDialog = true
      }

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    addressGroupId (newVal: number): void {
      if(newVal) {
        this.adressgruppe = newVal
      }
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: SelectAll | null): boolean {
      if(action instanceof SelectAll) {
        return !this.showDialog
      } else {
        return false
      }
    },

    selectAll (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      //@ts-ignore
      this.$refs.dataGrid.instance.selectAll()
    },

    onChangeFeld (index: number, item: any): void {
      if(item === 0) {
        this.additionalFilterList[index].feld = null
        this.additionalFilterList[index].operator = null
        this.additionalFilterList[index].inhalt = ''
        this.additionalFilterList[index].boolOperatorNext = 0
        this.additionalFilterList.splice(index + 1, this.additionalFilterList.length)
      }
    },

    onChangeAdditional (index: number, item: any): void {
      if(item === 0) {
        if(this.additionalFilterList && this.additionalFilterList[index + 1]) {
          this.additionalFilterList.splice(index + 1, 1)
        }
      } else {
        if(this.additionalFilterList && !this.additionalFilterList[index + 1]) {
          const highId = _.maxBy(this.additionalFilterList, 'id')
          this.additionalFilterList.push({id: highId.id + 1, feld: null, operator: null, inhalt: '', boolOperatorNext: 0})
        }
      }
    },

    startCreate (): void {
      this.addressIdList = [0]
    },

    addressCreated (id: number): void {
      this.addressIdList = [id]
    },

    addressEdited (): void {
      this.searchAddress()
    },

    addressDeleted (id: number) : void {
      this.addressIdList.splice(this.addressIdList.indexOf(id), 1)
      if(this.addressIdList.length === 0) {
        this.showDialog = false
        this.searchAddress()
      } else {
        this.searchAddress()
      }
    },

    onCloseDialog (): void {
      this.showDialog = false
      this.addressIdList = []
      let data: any = this.getRouteData()
      if(data.showDialog !== undefined) {
        delete data.showDialog
      }
      if(data.addressTab != undefined) {
        delete data.addressTab
      }
      if(data.addressIdIndex !== undefined) {
        delete data.addressIdIndex
      }
      if(data.addressTab2 !== undefined) {
        delete data.addressTab2
      }
      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(data) }})
      /*if(this.addressGroupId) {
        this.$router.push({ path: `/address/${this.addressGroupId}`})
      } else {
        this.$router.push({ path: '/address'})
      }*/
    },

    onSearchButtonClick (): void {
      this.addressList = []

      let data: any = this.getRouteData()

      data.sortierung = this.sortierung
      data.name = this.name
      data.vorname = this.vorname
      data.ort = this.ort
      data.plz = this.plz
      data.strasse = this.strasse
      data.hausnummer = this.hausnummer
      data.region = this.region
      data.land = this.land
      data.adressgruppe = this.adressgruppe
      data.telefonprivate = this.telefonprivate
      data.telefonGeschaeftlich = this.telefonGeschaeftlich
      data.handyprivat = this.handyprivat
      data.handygeschaeftlich = this.handygeschaeftlich
      data.mailprivat = this.mailprivat
      data.mailgeschaftlich = this.mailgeschaftlich
      data.addressStatus = this.addressStatus
      data.adressZusatzfelderSearchItems = this.additionalFilterList

      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(data) }})

      this.searchAddress()
    },

    onSelectionChanged (data: any) {
      this.isDetailButtonDisabled = data.selectedRowKeys.length <= 0

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = data.selectedRowKeys
      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(ruteData) }})
    },

    rowDblClick(event: any): void {
      this.addressIdList.push(event.data.id)
      this.showDialog = true

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = [event.data.id]
      ruteData.showDialog = this.showDialog
      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(ruteData) }})
    },

    onDetailClick (): void {
      //@ts-ignore
      const selectedAddressIdList: number[] = this.$refs.dataGrid.instance.getSelectedRowKeys()

      if(selectedAddressIdList.length > 0) {
        this.addressIdList = selectedAddressIdList
        this.showDialog = true

        let ruteData: any = this.getRouteData()
        ruteData.showDialog = this.showDialog
        this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(ruteData) }})
      }
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 105px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    async searchAddress (): Promise<void> {
      let additionalFilterSearchList: AdressZusatzfelderSearchItem[] = []
      this.additionalFilterList.forEach((item: any) => {
        if(item.feld && item.operator) {
          additionalFilterSearchList.push({
            Feldtyp: item.feld,
            Operator: item.operator,
            BoolOperatorNext: item.boolOperatorNext,
            Inhalt: item.inhalt
          })
        }
      })
      const payload: ProjectAddressSearchRequestPayload = {
        Sortierung: this.sortierung,
        Adressgruppe: this.adressgruppe ? this.adressgruppe.toString() : '',
        Name: this.name,
        Region: this.region,
        Vorname: this.vorname,
        Land: this.land ? this.land.name : '',
        Ort: this.ort,
        Telefonprivat: this.telefonprivate,
        Telefongeschaeftlich: this.telefonGeschaeftlich,
        Handyprivat: this.handyprivat,
        Handygeschaeftlich: this.handygeschaeftlich,
        AdressZusatzfelderSearchItems: additionalFilterSearchList,
        PLZ: this.plz,
        Mailprivat: this.mailprivat,
        Strasse: this.strasse,
        Hausnummer: this.hausnummer,
        Mailgeschaeftlich: this.mailgeschaftlich,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId,
        MaxRecords: this.maxRecords,
        Aktiv: this.addressStatus === '1',
        Passiv: this.addressStatus === '2',
        Alle: this.addressStatus === '0',
      }

      try {
        this.loading = true
        const response: ProjectAddressSearchResponse = await this.$store.dispatch(FETCH_SEARCH_ADDRESS_LIST, payload)
        if(!response.IsError) {
          this.addressList = SearchAddress.createFromResponse(response.Results)

          let data: any = this.getRouteData()
          if(this.$route.path === '/address' && data.selectedRowKeys) {
            let selectedRowKeyList: number[] = []
            this.addressList.forEach((item: SearchAddress) => {
              if(data.selectedRowKeys.includes(item.id)) {
                selectedRowKeyList.push(item.id)
              }
            })

            setTimeout(() => {
              //@ts-ignore
              this.$refs.dataGrid.instance.selectRows(selectedRowKeyList)
              this.showDialog = data.showDialog !== undefined && selectedRowKeyList.length > 0 ? data.showDialog : false
            }, 100)
          }
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    async fetchFeldList (): Promise<void> {
      try {
        const response: AdressZusatzfelderTypesResponse = await this.$store.dispatch(FETCH_ADDRESS_FELD_LIST)
        if(!response.IsError) {
          this.feldList = response.Data
          this.feldList.unshift({
            ID: 0,
            Bezeichnung: ''
          })
        }
      } catch {
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/address') {
        this.sortierung = data && data.sortierung ? data.sortierung : ''
        this.name = data && data.name ? data.name : ''
        this.vorname = data && data.vorname ? data.vorname : ''
        this.ort = data && data.ort ? data.ort : ''
        this.plz = data && data.plz ? data.plz : ''
        this.strasse = data && data.strasse ? data.strasse : ''
        this.hausnummer = data && data.hausnummer ? data.hausnummer : ''
        this.region = data && data.region ? data.region : ''
        this.land = data && data.land ? data.land : undefined
        this.adressgruppe = data && data.adressgruppe ? data.adressgruppe : undefined
        this.telefonprivate = data && data.telefonprivate ? data.telefonprivate : ''
        this.telefonGeschaeftlich = data && data.telefonGeschaeftlich ? data.telefonGeschaeftlich : ''
        this.handyprivat = data && data.handyprivat ? data.handyprivat : ''
        this.handygeschaeftlich = data && data.handygeschaeftlich ? data.handygeschaeftlich : ''
        this.mailprivat = data && data.mailprivat ? data.mailprivat : ''
        this.mailgeschaftlich = data && data.mailgeschaftlich ? data.mailgeschaftlich : ''
        this.addressStatus = data && data.addressStatus ? data.addressStatus : '1'
        this.additionalFilterList = data && data.adressZusatzfelderSearchItems ? data.adressZusatzfelderSearchItems : [{id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}]

        this.addressIdList = data.selectedRowKeys ? data.selectedRowKeys : []

        if(!_.isEmpty(data)) {
          this.searchAddress()
        }
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  beforeMount () {
    this.keyActions = [
      new SelectAll(KeyActionEnum.selectAll, this.selectAll, this.resolver,  null)
    ]
  },

  async mounted (): Promise<void> {
    window.addEventListener('keydown', this.onKeydown)

    this.setDataFromRoute()
    if(this.$route.query.create) {
      this.addressIdList = [0]
      this.showDialog = true
    }

    if(this.addressGroupId) {
      this.adressgruppe = this.addressGroupId
    }

    this.landList = await this.$store.dispatch(FETCH_LAND_LIST)
    this.addressGroupList = await this.$store.dispatch(FETCH_ADDRESS_GROUP)
    this.fetchFeldList()

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
